import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../../consts/Common';

const AlpineLandingPage = () => {
  const navigate = useNavigate();

  const redirect = (url: string) => {
    navigate(url);
  };

  useEffect(() => {
    redirect(PageAbsolutePath.Insurance.PolicyDocuments);
  });

  return <></>;
};

export default AlpineLandingPage;
